const topics = [
  { label: '刃牙漫画在线观看', count: '128.6万', hot: true },
  { label: '范马刃牙', count: '96.3万', hot: true },
  { label: '地下竞技场', count: '87.5万', hot: true },
  { label: '刃牙道', count: '82.1万', hot: true },
  { label: '刃牙VS勇次郎', count: '75.8万', hot: false },
  { label: '中国大擂台', count: '68.4万', hot: false },
  { label: '烈海王异世界', count: '61.2万', hot: false },
  { label: '花山薰外传', count: '53.7万', hot: false },
  { label: '格斗漫画推荐', count: '48.9万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          刃牙漫画社区热议话题与标签
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-300 ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200/70 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200/70 hover:bg-background-200/70'
              }`}
            >
              <span className={`text-sm font-medium ${topic.hot ? 'text-primary-600' : 'text-foreground-700'} whitespace-nowrap`}>
                {topic.label}
              </span>
              {topic.hot && (
                <span className="flex-shrink-0 px-1.5 py-0.5 rounded bg-primary-500 text-white text-xs font-medium whitespace-nowrap">热</span>
              )}
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}